'use client';

import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';

import { Spinner } from '@repo/ui/components/spinner';

const REDIRECT_DELAY = 1000 * 30; // 30 seconds
const FALLBACK_PATHNAME_TO_REDIRECT = '/home';

export const AppPage: React.FC = () => {
  const router = useRouter();

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      router.push(FALLBACK_PATHNAME_TO_REDIRECT);
    }, REDIRECT_DELAY);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [router]);

  return (
    <div className="dark flex size-full flex-1 flex-col text-black">
      <div className="flex flex-1 items-center justify-center">
        <div className="text-center">
          <Spinner className="mx-auto mb-3 size-8" />
          <p className="sr-only">Loading session...</p>
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-zinc-700 bg-black/50 px-4 py-2 opacity-70">
        <p className="text-center text-xs text-black">
          Skim Extension v0.0.24 • Building a more trustworthy internet
        </p>
      </div>
    </div>
  );
};
